import { useEffect } from "react"
import { useObject } from "react-firebase-hooks/database"
import { useHistory } from "react-router"
import { AuditoriumClosedRef } from "src/firebaseConfig"
import routes from "src/routes"

export const useAuditoriumController = (currentUser) => {
  const [snapshot, loading, error] = useObject(AuditoriumClosedRef)
  const history = useHistory()
  
  useEffect(() => {
    if (currentUser.role !== 'superadmin' && !loading && snapshot && snapshot.val() === '0') {
      history.push(routes.lobby + '?message=Auditorium is closed')
    }
  }, [snapshot])

  return !!snapshot
}
